module.exports = __webpack_public_path__ + "static/media/warning-icon.3a406a59.svg";